import { render, staticRenderFns } from "./DesktopManagerDialog.vue?vue&type=template&id=f6fbc338"
import script from "./DesktopManagerDialog.vue?vue&type=script&lang=js"
export * from "./DesktopManagerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports